/**
 * @generated SignedSource<<56e47737c7339d2b755b2c7c5677fdf4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useUpdateLastEditedTimestampVersionCacheLastEditedDraftVersionReadFragment$data = {
  readonly by: {
    readonly displayName: string | null;
  } | null;
  readonly when: string | null;
  readonly " $fragmentType": "useUpdateLastEditedTimestampVersionCacheLastEditedDraftVersionReadFragment";
};
export type useUpdateLastEditedTimestampVersionCacheLastEditedDraftVersionReadFragment$key = {
  readonly " $data"?: useUpdateLastEditedTimestampVersionCacheLastEditedDraftVersionReadFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"useUpdateLastEditedTimestampVersionCacheLastEditedDraftVersionReadFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useUpdateLastEditedTimestampVersionCacheLastEditedDraftVersionReadFragment",
  "selections": [
    {
      "kind": "LinkedField",
      "name": "by",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "displayName"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "when"
    }
  ],
  "type": "Version"
};

(node as any).hash = "52ad41feb7c48850dc9ff2da1dd55879";

export default node;
